import type { RouteLocationAsRelative } from 'vue-router'

export const siteRoutes = {
  settings: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/settings/(organizations)/'> => ({
    name: '/(app)/[org]/settings/(organizations)/',
    params: { org },
  }),

  shiftPresets: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/settings/(organizations)/shift-presets'> => ({
    name: '/(app)/[org]/settings/(organizations)/shift-presets',
    params: { org },
  }),

  subscription: (
    org: string,
  ): RouteLocationAsRelative<'/(app)/[org]/settings/(organizations)/subscription'> => ({
    name: '/(app)/[org]/settings/(organizations)/subscription',
    params: { org },
  }),
}
